import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import dayjs from "dayjs";

import styles from "./Main.module.css";
import {
  ExclamationCircleFilled,
  DeleteOutlined,
  QuestionOutlined,
} from "@ant-design/icons";

import {
  Button,
  Card,
  Checkbox,
  DatePicker,
  Form,
  Input,
  Modal,
  Radio,
  Select,
  Table,
  notification,
} from "antd";
import { AppContext } from "../App.context";
import axios from "axios";
import {
  checkEmpty,
  createUserApi,
  getAboteOpen,
  getAboteOpenUtil,
  getAboutLot,
  getCurrentDateUtil,
  getCurrentDateUtilYYYY,
  getDateUtilYYYY,
  getLot,
  getLotCloses,
  getLotResualts,
  getToken,
  getUsers,
  indexMore,
  isAdmin,
  parseJwt,
  pathRoutes,
  reverseString19,
  reverseString2,
  reverseString3,
  rmPreventApi,
  rmlotResualtApi,
  saveBilApi,
  saveLotDateNextApi,
  saveLotPayApi,
  savePostUtilApi,
  savePreventNumAllApi,
  savePreventNumApi,
  savePreventNumUsernameApi,
  savelotResualtApi,
  subStringText,
} from "../service/util.service";
import { useNavigate, useSearchParams } from "react-router-dom";
import PrivateRoute from "../menu/PrivateRoute";
import MenuTop from "../menu/MenuTop";
import MenuLett from "../menu/Menu";
import CardLot from "../card/CardLot";
import Countdown from "react-countdown";
import LoadingCenterSpinSmalljs from "./LoadingCenterSpinSmall";
import LoadingCenterSpinSmall from "./LoadingCenterSpinSmall";
import LoadingCenterSpinSmallBlue from "./LoadingCenterSpinSmallBlue";
const { confirm } = Modal;

const lotTypes = [
  {
    key: "lot_2",
    name: "2 ตัว",
    text1: "+ เลขเบิ้ล",
    text2: "บน",
    text3: "ล่าง",
  },
  {
    key: "lot_3",
    name: "3 ตัว",
    text1: "+ เลขตอง",
    text2: "บน",
    text3: "โต๊ด",
  },
  { key: "lot_6", name: "6 กลับ" },
  { key: "lot_19", name: "19 ประตู", text1: "บน", text2: "ล่าง" },
  { key: "lot_run", name: "วิ่งเลข", text1: "วิ่งบน", text2: "วิ่งล่าง" },
  { key: "lot_win", name: "เลขวิน" },
];

function LotResualtSet(props) {
  return (
    <>
      <MenuLett />
      <div className={styles.boxMain}>
        <MenuTop />
        <Content />
      </div>
    </>
  );
}

function Content(props) {
  const appContext = useContext(AppContext);
  const [modal, contextHolder] = Modal.useModal();
  const navigate = useNavigate();
  const [lot, setLot] = useState({});
  const [lotId, setLotId] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [lotResualts, setLotResualts] = useState([]);
  const [lotPays, setlotPays] = useState([]);
  const [lotResualtToRm, setlotResualtToRm] = useState(null);

  const [lotTop, setLotTop] = useState("");
  const [lotBottom, setLotBottom] = useState("");
  const [lotDate, setLotDate] = useState("");
  const [lotDateNext, setLotDateNext] = useState("");
  const [lotDateClose, setLotDateClose] = useState("");
  const [loadingSave, setLoadingSave] = useState(false);
  const [loadingRm, setLoadingRm] = useState(false);
  const [loadingSaveNext, setLoadingSaveNext] = useState(false);
  const [loadingSaveTime, setLoadingSaveTime] = useState(false);
  const [loadingPaySave, setloadingPaySave] = useState(false);
  const [loadingPreventSave, setloadingPreventSave] = useState(false);
  const [loadingCloseSave, setloadingCloseSave] = useState(false);
  const [loadingPreventDelete, setloadingPreventDelete] = useState(false);
  const [loadingCloseDelete, setloadingCloseDelete] = useState(false);
  const [isAdminMain, setIsAdminMain] = useState(false);

  const [lotPay_2, setLotPay_2] = useState("");
  const [lotPay_3, setLotPay_3] = useState("");
  const [lotPay_3_tot, setLotPay_3_tot] = useState("");
  const [lotPay_run_top, setLotPay_run_top] = useState("");
  const [lotPay_run_bottom, setLotPay_run_bottom] = useState("");

  const [prevent_num_type, setprevent_num_type] = useState("lot_2");
  const [prevent_num, setprevent_num] = useState("");
  const [prevent_price, setprevent_price] = useState("");

  const [prevent_num_type_rm, setprevent_num_type_rm] = useState("");
  const [prevent_num_rm, setprevent_num_rm] = useState("");
  const [prevent_price_rm, setprevent_price_rm] = useState("");
  const [prevent_id_rm, setprevent_id_rm] = useState("");
  const [prevent_id_edit, setprevent_id_edit] = useState("");

  const [userOptions, setUserOptions] = useState([]);
  const [userOptionSelected, setUserOptionSelected] = useState(null);
  const [lotPrevent, setLotPrevent] = useState([]);
  const [lotClosees, setLotClosees] = useState([]);
  const [loadingRmPrevent, setLoadingRmPrevent] = useState(false);
  const [loadingPreventData, setLoadingPreventData] = useState(false);
  const refvaluetop = useRef(null);

  const [close_num_type, setclose_num_type] = useState("lot_2");
  const [close_num, setclose_num] = useState("");
  const [close_num_id, setclose_num_id] = useState("");
  const [close_price, setclose_price] = useState("");
  const [close_date, setclose_date] = useState("");
  const [loadingRmClose, setLoadingRmClose] = useState(false);
  const [myUser, setMyUser] = useState({});

  const savePreventRef = useRef(null);
  const numPreventRef = useRef(null);
  const pricePreventRef = useRef(null);
  const typePreventRef = useRef(null);
  const saveCloseRef = useRef(null);
  const valueCloseRef = useRef(null);

  const saveTimeRef = useRef(null);
  const valueTimeRef = useRef(null);

  const saveNextRef = useRef(null);
  const valueNextRef = useRef(null);

  const saveResualtRef = useRef(null);
  const valueTopRef = useRef(null);
  const valueBottomRef = useRef(null);

  const loadData = async () => {
    let lot_id = searchParams.get("lot_id");
    setLotId(lot_id);
    // console.log("lot_id:", lot_id);
    if (checkEmpty(lot_id)) {
      navigate(pathRoutes.main);
    } else {
      try {
        let lotDetail = await getLot(lot_id, appContext.acUsername);
        console.log("lotDetail", lotDetail);
        setLot(lotDetail);
        reflectorLotDetail(lotDetail);

        setLotDateClose(lotDetail.lot_time_close);
        reflectorLotPrevent(lotDetail.prevent_numbers);
        // setLotDate(lotDateUse);
        // setclose_date(lotDateUse);
        // setLotDateNext(lotDateUse);
      } catch (e) {
        console.log(e);
      }
    }
  };
  const getResualtData = async () => {
    let lot_id = searchParams.get("lot_id");
    try {
      let lotResultsTemp = await getLotResualts(lot_id);
      reflectorLotResualt(lotResultsTemp);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getResualtData();
  }, []);
  const getUserData = async () => {
    try {
      let usersTemp = await getUsers();
      // console.log("users", users);
      let users = [];
      for (let a = 0; a < usersTemp.length; a++) {
        if (a == 0) {
          setUserOptionSelected(usersTemp[a].username);
        }
        let user = { value: usersTemp[a].username };
        users.push(user);
      }
      setUserOptions(Object.assign([], users));
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getUserData();
  }, []);

  const getClose = async () => {
    let lot_id = searchParams.get("lot_id");
    try {
      let lotCloses = await getLotCloses(lot_id);
      reflectorLotClose(lotCloses);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getClose();
  }, []);

  useEffect(() => {
    // return getCurrentDateUtil();

    let res = getAboteOpenUtil(lot);
    let lotDateUse = getCurrentDateUtilYYYY();
    if (!checkEmpty(lot.lot_date) && lot.date_type_allow != "some_days")
      lotDateUse = lot.lot_date;
    else {
      lotDateUse = res.lot_date;
    }

    setLotDate(lotDateUse);
    setclose_date(lotDateUse);
    setLotDateNext(lotDateUse);
  }, [lot]);

  const reflectorLotClose = (datatemp) => {
    let datas = [];
    for (let a = 0; a < datatemp.length; a++) {
      let object = datatemp[a];
      let num = object.close_number;
      let type = object.close_number_type;
      let date = getDateUtilYYYY(object.lot_date);
      let data = {
        num: {
          text: num,
          fontWeight: "bold",
        },
        date: { text: date, fontWeight: "bold" },
        type: { text: type, fontWeight: "bold" },
        edit: {
          fontWeight: "bold",
          num: num,
          date: date,
          type: type,
          close_number_id: object.close_number_id,
        },
        rm: {
          fontWeight: "bold",
          num: num,
          date: date,
          type: type,
          close_number_id: object.close_number_id,
        },
      };
      datas.push(data);
    }
    setLotClosees(Object.assign([], datas));
  };

  const reflectorLotDetail = (lotDetail) => {
    let datas = [];
    let data = {
      pay_2: {
        text: lotDetail.pay_2,
      },
      pay_3: {
        text: lotDetail.pay_3,
      },
      pay_3_tot: {
        text: lotDetail.pay_tot_price,
      },
      pay_run_top: {
        text: lotDetail.pay_run_top,
      },
      pay_run_bottom: {
        text: lotDetail.pay_run_bottom,
      },
    };
    datas.push(data);
    // console.log("datas",datas)
    setLotPay_2(lotDetail.pay_2);
    setLotPay_3(lotDetail.pay_3);
    setLotPay_3_tot(lotDetail.pay_tot_price);
    setLotPay_run_top(lotDetail.pay_run_top);
    setLotPay_run_bottom(lotDetail.pay_run_bottom);
    setlotPays(Object.assign([], datas));
  };

  const reflectorLotResualt = (lotResultsTemp) => {
    let datas = [];
    for (let a = 0; a < lotResultsTemp.length; a++) {
      let resualt = lotResultsTemp[a];
      let data = {
        lot_date: {
          text: getDateUtilYYYY(resualt.lot_date),
          fontWeight: "bold",
        },
        lot_top: { text: resualt.lot_top, fontWeight: "bold" },
        lot_bottom: { text: resualt.lot_bottom, fontWeight: "bold" },
        edit: {
          lot_date: getDateUtilYYYY(resualt.lot_date),
          fontWeight: "bold",
          lot_top: resualt.lot_top,
          lot_bottom: resualt.lot_bottom,
        },
        rm: {
          lot_resualt_id: resualt.lot_resualt_id,
          fontWeight: "bold",
        },
      };
      datas.push(data);
    }
    setLotResualts(Object.assign([], datas));
  };

  useEffect(() => {
    try {
      let user = parseJwt(getToken());
      console.log(user);
      setMyUser(user);
    } catch (e) {}

    loadData();
    // setLotDate(getCurrentDateUtilYYYY());
    // setclose_date(getCurrentDateUtilYYYY());
    if (!checkEmpty(getToken())) {
      if (isAdmin()) {
        setIsAdminMain(true);
      } else {
        setIsAdminMain(false);
      }
    }
  }, []);

  useEffect(() => {
    try {
      refvaluetop.current.focus();
    } catch (e) {
      console.log(e);
    }
  }, [isAdminMain]);

  const columns = [
    {
      title: "วันที่",
      dataIndex: "lot_date",
      key: "lot_date",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { lot_date }) => (
        <>
          <span style={{ color: "green", fontWeight: lot_date.fontWeight }}>
            {lot_date.text}
          </span>
        </>
      ),
    },
    {
      title: "3 ตัว",
      dataIndex: "lot_top",
      key: "lot_top",
      // render: (text) => <span style={{ color: "blue" }}>{text}</span>,
      render: (_, { lot_top }) => (
        <>
          <span style={{ color: "blue", fontWeight: lot_top.fontWeight }}>
            {lot_top.text}
          </span>
        </>
      ),
    },
    {
      title: "2 ตัว",
      key: "lot_bottom",
      dataIndex: "lot_bottom",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { lot_bottom }) => (
        <>
          <span style={{ color: "green", fontWeight: lot_bottom.fontWeight }}>
            {lot_bottom.text}
          </span>
        </>
      ),
    },
    ,
    {
      title: (isAdminMain || true) ? "แก้ไข" : "",
      key: "edit",
      dataIndex: "edit",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { edit }) => (
        <>
          {(isAdminMain || true) && (
            <>
              {" "}
              <span
                style={{
                  color: "green",
                  fontWeight: edit.fontWeight,
                  cursor: "pointer",
                }}
                onClick={() => {
                  setLotDate(edit.lot_date);
                  setLotTop(edit.lot_top);
                  setLotBottom(edit.lot_bottom);
                }}
              >
                แก้ไข
              </span>
            </>
          )}
        </>
      ),
    },

    {
      title: (isAdminMain || true) ? "ลบ" : "",
      key: "rm",
      dataIndex: "rm",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { rm }) => (
        <>
          {(isAdminMain || true) && (
            <>
              {rm.lot_resualt_id == lotResualtToRm && loadingRm ? (
                <LoadingCenterSpinSmallBlue />
              ) : (
                <>
                  {" "}
                  <span
                    style={{
                      color: "red",
                      fontWeight: rm.fontWeight,
                      cursor: "pointer",
                    }}
                    onClick={async () => {
                      setlotResualtToRm(rm.lot_resualt_id);
                      await showConfirmRm(rm.lot_resualt_id);
                      // setLotDate(rm.lot_resualt_id);
                      // setLotTop(rm.lot_top);
                      // setLotBottom(rm.lot_bottom);
                    }}
                  >
                    ลบ
                  </span>
                </>
              )}
            </>
          )}
        </>
      ),
    },
  ];

  const columnPays = [
    {
      title: "2 ตัว",
      dataIndex: "pay_2",
      key: "pay_2",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { pay_2 }) => (
        <>
          <Input
            type="number"
            className={styles.setPayInput}
            placeholder={"2 ตัว"}
            value={lotPay_2}
            onChange={(e) => {
              let value = e.target.value;
              value = value.trim();
              setLotPay_2(value);
            }}
            onKeyDown={(e) => {
              let value = e.target.value;
              value = value.trim();
              setLotPay_2(value);
            }}
            onWheel={(e) => {
              e.target.blur();
              e.stopPropagation();
            }}
          />
        </>
      ),
    },
    {
      title: "3 ตัวตรง",
      dataIndex: "pay_3",
      key: "pay_3",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { pay_3 }) => (
        <>
          <Input
            type="number"
            className={styles.setPayInput}
            placeholder={"2 ตัว"}
            value={lotPay_3}
            onChange={(e) => {
              let value = e.target.value;
              value = value.trim();
              setLotPay_3(value);
            }}
            onKeyDown={(e) => {
              let value = e.target.value;
              value = value.trim();
              setLotPay_3(value);
            }}
            onWheel={(e) => {
              e.target.blur();
              e.stopPropagation();
            }}
          />
        </>
      ),
    },
    {
      title: "3 ตัวโต๊ด",
      dataIndex: "pay_3_tot",
      key: "pay_3_tot",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { pay_3_tot }) => (
        <>
          <Input
            type="number"
            className={styles.setPayInput}
            placeholder={"3 ตัวโต๊ด"}
            value={lotPay_3_tot}
            onChange={(e) => {
              let value = e.target.value;
              value = value.trim();
              setLotPay_3_tot(value);
            }}
            onKeyDown={(e) => {
              let value = e.target.value;
              value = value.trim();
              setLotPay_3_tot(value);
            }}
            onWheel={(e) => {
              e.target.blur();
              e.stopPropagation();
            }}
          />
        </>
      ),
    },
    {
      title: "วิ่งบน",
      dataIndex: "pay_run_top",
      key: "pay_run_top",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { pay_run_top }) => (
        <>
          <Input
            type="number"
            className={styles.setPayInput}
            placeholder={"วิ่งบน"}
            value={lotPay_run_top}
            onChange={(e) => {
              let value = e.target.value;
              value = value.trim();
              setLotPay_run_top(value);
            }}
            onKeyDown={(e) => {
              let value = e.target.value;
              value = value.trim();
              setLotPay_run_top(value);
            }}
            onWheel={(e) => {
              e.target.blur();
              e.stopPropagation();
            }}
          />
        </>
      ),
    },
    {
      title: "วิ่งล่าง",
      dataIndex: "pay_run_bottom",
      key: "pay_run_bottom",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { pay_run_bottom }) => (
        <>
          <Input
            type="number"
            className={styles.setPayInput}
            placeholder={"วิ่งล่าง"}
            value={lotPay_run_bottom}
            onChange={(e) => {
              let value = e.target.value;
              value = value.trim();
              setLotPay_run_bottom(value);
            }}
            onKeyDown={(e) => {
              let value = e.target.value;
              value = value.trim();
              setLotPay_run_bottom(value);
            }}
            onWheel={(e) => {
              e.target.blur();
              e.stopPropagation();
            }}
          />
        </>
      ),
    },
  ];

  const rmlotResualt = async (lot_resualt_id) => {
    let body = {
      lot_resualt_id: lot_resualt_id,

      lotId: lotId,
    };
    try {
      setLoadingRm(true);
      let datas = await rmlotResualtApi(body);
      reflectorLotResualt(datas);
      setLotBottom("");
      setLotTop("");
      setLoadingRm(false);
      openNotificationWithIcon("success", "การจ่าย", "บันทึกการจ่ายสำเร็จ");
    } catch (e) {
      setLoadingRm(false);
      openNotificationWithIcon("error", "การจ่าย", "บันทึกการจ่ายไม่สำเร็จ");
    }
  };

  const savelotResualt = async () => {
    let body = {
      lotId: lotId,
      lotTop: lotTop,
      lotBottom: lotBottom,
      lotDate: lotDate,
    };
    try {
      setLoadingSave(true);
      let datas = await savelotResualtApi(body);
      reflectorLotResualt(datas);
      setLotBottom("");
      setLotTop("");
      setLoadingSave(false);
    } catch (e) {
      setLoadingSave(false);
    }
  };

  const showSaveConfirm = () => {
    if (checkEmpty(lotTop) || checkEmpty(lotBottom)) {
      const config = {
        title: "ลงหวย",
        content: <>ยังไม่ใส่ข้อมูล</>,
      };
      modal.error(config);
      return;
    }
    confirm({
      title: "บันทึก",
      icon: <QuestionOutlined />,
      content: "ยืนยันบันทึกหวยนี้",
      okText: "ยืนยัน",
      // okType: 'danger',
      cancelText: "ยกเลิก",
      onOk() {
        console.log("OK");
        savelotResualt();
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const showConfirmRm = (lot_resualt_id) => {
    confirm({
      title: "ลบ",
      icon: <QuestionOutlined />,
      content: "ยืนยันลบหวยนี้",
      okText: "ยืนยัน",
      // okType: 'danger',
      cancelText: "ยกเลิก",
      onOk() {
        rmlotResualt(lot_resualt_id);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const showSaveConfirmDateClose = () => {
    if (checkEmpty(lotDateClose)) {
      const config = {
        title: "เวลาปิดรับ",
        content: <>ใส่เวลาปิดรับ</>,
      };
      modal.error(config);
      return;
    }
    confirm({
      title: "บันทึก",
      icon: <QuestionOutlined />,
      content: "ยืนยันบันทึกเวลาปิดรับ",
      okText: "ยืนยัน",
      // okType: 'danger',
      cancelText: "ยกเลิก",
      onOk() {
        console.log("OK");
        savelotDateClose();
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };
  const showSaveConfirmNext = () => {
    if (checkEmpty(lotDateNext)) {
      const config = {
        title: "วันหวยออก",
        content: <>ใส่วันหวยออก</>,
      };
      modal.error(config);
      return;
    }
    confirm({
      title: "บันทึก",
      icon: <QuestionOutlined />,
      content: "ยืนยันบันทึกวันหวยออก",
      okText: "ยืนยัน",
      // okType: 'danger',
      cancelText: "ยกเลิก",
      onOk() {
        console.log("OK");
        savelotDateNext();
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const showSavePayConfirm = () => {
    if (checkEmpty(appContext.acUsername)) {
      const config = {
        title: "การจ่าย",
        content: <>ไม่ได้เลือกผู้ใช้</>,
      };
      modal.error(config);
      return;
    }
    confirm({
      title: "บันทึก",
      icon: <QuestionOutlined />,
      content: "ยืนยันบันทึกการจ่าย",
      okText: "ยืนยัน",
      // okType: 'danger',
      cancelText: "ยกเลิก",
      onOk() {
        console.log("OK");
        savePay();
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const savePay = async () => {
    try {
      let body = {
        lot_id: lot.lot_id,
        username: appContext.acUsername,
        pay_tot_price: lotPay_3_tot,
        pay_2: lotPay_2,
        pay_3: lotPay_3,
        pay_run_top: lotPay_run_top,
        pay_run_bottom: lotPay_run_bottom,
      };
      setloadingPaySave(true);
      let lotDetail = await saveLotPayApi(body);
      console.log("lotDetail save pay", lotDetail);
      reflectorLotDetail(lotDetail);
      setloadingPaySave(false);
      openNotificationWithIcon("success", "การจ่าย", "บันทึกการจ่ายสำเร็จ");
      localStorage.removeItem("aboutLot");
      // localStorage.removeItem("")
    } catch (e) {
      setloadingPaySave(false);
      openNotificationWithIcon("error", "การจ่าย", "บันทึกการจ่ายไม่สำเร็จ");
    }
  };

  const [api, contextHolderDone] = notification.useNotification();

  const openNotificationWithIcon = (type, title, message) => {
    api[type]({
      message: title,
      description: message,
    });
  };
  const savelotDateNext = async () => {
    try {
      let body = {
        lot_id: lot.lot_id,
        lot_date: lotDateNext,
      };
      setLoadingSaveNext(true);
      await saveLotDateNextApi(body);
      setLoadingSaveNext(false);
      // openNotificationWithIcon("success", "วันหวยออก", "บันทึกวันหวยออกสำเร็จ");
      localStorage.removeItem("aboutLot");
      // localStorage.removeItem("")
    } catch (e) {
      setLoadingSaveNext(false);
      openNotificationWithIcon(
        "error",
        "วันหวยออก",
        "บันทึกวันหวยออกไม่สำเร็จ"
      );
    }
  };

  const savelotDateClose = async () => {
    try {
      setLoadingSaveTime(true);
      let body = {
        lot_id: lot.lot_id,
        lot_time_close: lotDateClose,
      };
      await saveLotDateNextApi(body);
      openNotificationWithIcon(
        "success",
        "เวลาปิดรับ",
        "บันทึกเวลาปิดรับสำเร็จ"
      );
      localStorage.removeItem("aboutLot");
      // localStorage.removeItem("")
      setLoadingSaveTime(false);
    } catch (e) {
      openNotificationWithIcon(
        "error",
        "เวลาปิดรับ",
        "บันทึกเวลาปิดรับไม่สำเร็จ"
      );
      setLoadingSaveTime(false);
    }
  };

  const deletePreventAll = async () => {
    let body = {
      lot_id: lotId,
      username: appContext.acUsername,
    };
    try {
      setloadingPreventDelete(true);
      let datas = await savePreventNumAllApi(body);
      reflectorLotPrevent(datas);
      setloadingPreventDelete(false);
      openNotificationWithIcon("success", "หวยอั้น", "ลบหวยอั้นทั้งหมดสำเร็จ");
    } catch (e) {
      setloadingPreventDelete(false);
      openNotificationWithIcon(
        "success",
        "หวยอั้น",
        "ลบหวยอั้นทั้งหมดไม่สำเร็จ"
      );
    }
  };

  const showConfirmDeleteAll = () => {
    confirm({
      title: "บันทึก",
      icon: <QuestionOutlined />,
      content: "ยืนยันลบหวยอั้นทั้งหมด",
      okText: "ยืนยัน",
      // okType: 'danger',
      cancelText: "ยกเลิก",
      onOk() {
        console.log("OK");
        deletePreventAll();
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const showSavePreventConfirm = () => {
    if (checkEmpty(prevent_num) || checkEmpty(prevent_price)) {
      const config = {
        title: "หวยอั้น",
        content: <>ยังไม่ใส่ข้อมูล</>,
      };
      modal.error(config);
      return;
    }

    savePreventNum();
  };

  const deleteCloseAll = async () => {
    let body = {
      lot_id: lotId,
      username: appContext.acUsername,
    };
    try {
      setloadingCloseDelete(true);
      let datas = await savePostUtilApi("delete-all-number-close", body);
      reflectorLotClose(datas);
      setloadingCloseDelete(false);
      openNotificationWithIcon(
        "success",
        "หวยปิดรับ",
        "ลบหวยปิดรับทั้งหมดสำเร็จ"
      );
    } catch (e) {
      setloadingCloseDelete(false);
      openNotificationWithIcon(
        "success",
        "หวยปิดรับ",
        "ลบหวยปิดรับทั้งหมดไม่สำเร็จ"
      );
    }
  };

  const showConfirmDeleteAllClose = () => {
    confirm({
      title: "บันทึก",
      icon: <QuestionOutlined />,
      content: "ยืนยันลบปิดรับทั้งหมด",
      okText: "ยืนยัน",
      // okType: 'danger',
      cancelText: "ยกเลิก",
      onOk() {
        console.log("OK");
        deleteCloseAll();
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };
  const showSaveCloseConfirm = (close_num) => {
    if (checkEmpty(close_num) || checkEmpty(close_date)) {
      const config = {
        title: "ปิดรับ",
        content: <>ยังไม่ใส่ข้อมูล</>,
      };
      modal.error(config);
      return;
    }

    saveCloseNum(close_num);
  };

  const saveCloseNum = async (close_num) => {
    let num = close_num;
    // if (num < 10) num = "0" + num;
    let body = {
      lot_id: lotId,
      close_number: num,
      close_number_type: close_num_type,
      close_number_id: close_num_id,
      lot_date: close_date,
    };
    try {
      setloadingCloseSave(true);
      let datas = await savePostUtilApi("save-number-close", body);
      reflectorLotClose(datas);
      // setclose_num("");
      setclose_num_id("");
      // setprevent_num_type("lot_2");
      setloadingCloseSave(false);
      openNotificationWithIcon("success", "หวยปิดรับ", "บันทึกหวยปิดรับสำเร็จ");
    } catch (e) {
      setloadingCloseSave(false);
      openNotificationWithIcon(
        "success",
        "หวยปิดรับ",
        "บันทึกหวยปิดรับไม่สำเร็จ"
      );
    }
  };

  const showSavePreventDataConfirm = () => {
    if (checkEmpty(userOptionSelected)) {
      const config = {
        title: "หวยอั้น",
        content: <>ยังไม่ใส่ข้อมูล</>,
      };
      modal.error(config);
      return;
    }
    confirm({
      title: "บันทึก",
      icon: <QuestionOutlined />,
      content: "ยืนยันดึงข้อหวยอั้นนี้จากผู้ใช้ (ข้อมูลเดิมจะหายไป)",
      okText: "ยืนยัน",
      // okType: 'danger',
      cancelText: "ยกเลิก",
      onOk() {
        console.log("OK");
        savePreventNumData();
      },
      onCancel() {
        console.log("Cancel");
      },
    });

    // savePreventNum();
  };
  const savePreventNumData = async () => {
    let body = {
      lot_id: lotId,
      username: appContext.acUsername,
      from_username: userOptionSelected,
    };
    try {
      setLoadingPreventData(true);
      let datas = await savePreventNumUsernameApi(body);
      reflectorLotPrevent(datas);
      setLoadingPreventData(false);
      openNotificationWithIcon(
        "success",
        "หวยอั้น",
        "ดึงข้อหวยอั้นนี้จากผู้ใช้สำเร็จ"
      );
    } catch (e) {
      setLoadingPreventData(false);
      openNotificationWithIcon(
        "success",
        "หวยอั้น",
        "ดึงข้อหวยอั้นนี้จากผู้ใช้ไม่สำเร็จ"
      );
    }
  };

  const savePreventNum = async () => {
    let num = prevent_num;
    // if (num < 10) num = "0" + num;
    let body = {
      lot_id: lotId,
      prevent_number: num,
      prevent_number_type: prevent_num_type,
      price: prevent_price,
      username: appContext.acUsername,
      prevent_number_id: prevent_id_edit,
    };
    try {
      setloadingPreventSave(true);
      let datas = await savePreventNumApi(body);
      reflectorLotPrevent(datas);
      setprevent_num("");
      setprevent_price("");
      setprevent_id_edit("");
      // setprevent_num_type("lot_2");
      setloadingPreventSave(false);
      openNotificationWithIcon("success", "หวยอั้น", "บันทึกหวยอั้นสำเร็จ");
    } catch (e) {
      setloadingPreventSave(false);
      openNotificationWithIcon("success", "หวยอั้น", "บันทึกหวยอั้นไม่สำเร็จ");
    }
  };

  const reflectorLotPrevent = (datatemp) => {
    let datas = [];
    for (let a = 0; a < datatemp?.length; a++) {
      let object = datatemp[a];
      let num = object.prevent_number;
      let type = object.prevent_number_type;
      let price = object.price;
      let data = {
        num: {
          text: num,
          fontWeight: "bold",
        },
        price: { text: price, fontWeight: "bold" },
        type: { text: type, fontWeight: "bold" },
        edit: {
          fontWeight: "bold",
          num: num,
          price: price,
          type: type,
          prevent_number_id: object.prevent_number_id,
        },
        rm: {
          fontWeight: "bold",
          num: num,
          price: price,
          type: type,
          prevent_number_id: object.prevent_number_id,
        },
      };
      datas.push(data);
    }
    setLotPrevent(Object.assign([], datas));
  };
  const getTextType = (type) => {
    if (type == "lot_2") {
      return "2 ตัวตรง";
    } else if (type == "lot_3_top") {
      return "3 ตัวตรง";
    } else if (type == "lot_3_tot") {
      return "3 ตัวโต๊ด";
    }
  };

  const getTextTypeClose = (type) => {
    if (type == "lot_2") {
      return "2 ตัว";
    } else if (type == "lot_3") {
      return "3 ตัว";
    }
  };

  const columnPrevents = [
    {
      title: "เลข",
      dataIndex: "num",
      key: "num",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { num }) => (
        <>
          <span style={{ color: "green", fontWeight: num.fontWeight }}>
            {num.text}
          </span>
        </>
      ),
    },
    {
      title: "จ่ายราคา",
      dataIndex: "price",
      key: "price",
      // render: (text) => <span style={{ color: "blue" }}>{text}</span>,
      render: (_, { price }) => (
        <>
          <span style={{ color: "blue", fontWeight: price.fontWeight }}>
            {price.text}
          </span>
        </>
      ),
    },
    {
      title: "ชนิดหวย",
      key: "type",
      dataIndex: "type",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { type }) => (
        <>
          <span style={{ color: "green", fontWeight: type.fontWeight }}>
            {getTextType(type.text)}
          </span>
        </>
      ),
    },
    ,
    {
      // title: (isAdminMain || true) ? "แก้ไข" : "",
      title: "แก้ไข",
      key: "edit",
      dataIndex: "edit",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { edit }) => (
        <>
          {/* {(isAdminMain || true) && ( */}
          <>
            {" "}
            <span
              style={{
                color: "green",
                fontWeight: edit.fontWeight,
                cursor: "pointer",
              }}
              onClick={() => {
                setprevent_num(edit.num);
                setprevent_num_type(edit.type);
                setprevent_price(edit.price);
                setprevent_id_edit(edit.prevent_number_id);
              }}
            >
              แก้ไข
            </span>
          </>
          {/* )} */}
        </>
      ),
    },

    {
      // title: (isAdminMain || true) ? "ลบ" : "",
      title: "ลบ",
      key: "rm",
      dataIndex: "rm",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { rm }) => (
        <>
          {/* {(isAdminMain || true) && ( */}
          <>
            {rm.prevent_number_id == prevent_id_rm && loadingRmPrevent ? (
              <LoadingCenterSpinSmallBlue />
            ) : (
              <>
                {" "}
                <span
                  style={{
                    color: "red",
                    fontWeight: rm.fontWeight,
                    cursor: "pointer",
                  }}
                  onClick={async () => {
                    setprevent_num_rm(rm.num);
                    setprevent_num_type_rm(rm.type);
                    setprevent_price_rm(rm.price);
                    setprevent_id_rm(rm.prevent_number_id);
                    await showConfirmRmPrevent(rm.prevent_number_id);
                  }}
                >
                  ลบ
                </span>
              </>
            )}
          </>
          {/* )} */}
        </>
      ),
    },
  ];

  const columnCloses = [
    {
      title: "เลข",
      dataIndex: "num",
      key: "num",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { num }) => (
        <>
          <span style={{ color: "green", fontWeight: num.fontWeight }}>
            {num.text}
          </span>
        </>
      ),
    },
    {
      title: "ชื่องวด",
      dataIndex: "date",
      key: "date",
      // render: (text) => <span style={{ color: "blue" }}>{text}</span>,
      render: (_, { date }) => (
        <>
          <span style={{ color: "blue", fontWeight: date.fontWeight }}>
            {date.text}
          </span>
        </>
      ),
    },
    {
      title: "ชนิดหวย",
      key: "type",
      dataIndex: "type",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { type }) => (
        <>
          <span style={{ color: "green", fontWeight: type.fontWeight }}>
            {getTextTypeClose(type.text)}
          </span>
        </>
      ),
    },
    ,
    {
      title: (isAdminMain || true) ? "แก้ไข" : "",
      // title: "แก้ไข",
      key: "edit",
      dataIndex: "edit",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { edit }) => (
        <>
          {(isAdminMain || true) && (
            <>
              {" "}
              <span
                style={{
                  color: "green",
                  fontWeight: edit.fontWeight,
                  cursor: "pointer",
                }}
                onClick={() => {
                  setclose_num(edit.num);
                  setclose_num_type(edit.type);
                  setclose_date(edit.date);
                  setclose_num_id(edit.close_number_id);
                }}
              >
                แก้ไข
              </span>
            </>
          )}
        </>
      ),
    },

    {
      title: (isAdminMain || true) ? "ลบ" : "",
      // title: "ลบ",
      key: "rm",
      dataIndex: "rm",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { rm }) => (
        <>
          {(isAdminMain || true) && (
            <>
              {rm.close_number_id == close_num_id && loadingRmClose ? (
                <LoadingCenterSpinSmallBlue />
              ) : (
                <>
                  {" "}
                  <span
                    style={{
                      color: "red",
                      fontWeight: rm.fontWeight,
                      cursor: "pointer",
                    }}
                    onClick={async () => {
                      // setclose_num(edit.num);
                      // setclose_num_type(edit.type);
                      // setclose_price(edit.date);
                      // setclose_id(edit.close_number_id);
                      await showConfirmRmClose(rm.close_number_id);
                    }}
                  >
                    ลบ
                  </span>
                </>
              )}
            </>
          )}
        </>
      ),
    },
  ];

  const showConfirmRmClose = (close_number_id) => {
    rmClose(close_number_id);
  };

  const rmClose = async (close_number_id) => {
    let body = {
      lot_id: lotId,
      close_number_id: close_number_id,
    };
    try {
      setLoadingRmClose(true);
      let datas = await savePostUtilApi("rm-number-close", body);
      reflectorLotClose(datas);
      setLoadingRmClose(false);
      openNotificationWithIcon("success", "หวยปิดรับ", "ลบหวยปิดรับสำเร็จ");
    } catch (e) {
      setLoadingRmClose(false);
      openNotificationWithIcon("error", "หวยปิดรับ", "ลบหวยปิดรับไม่สำเร็จ");
    }
  };

  const showConfirmRmPrevent = (prevent_number_id) => {
    rmPrevent(prevent_number_id);
  };

  const rmPrevent = async (prevent_number_id) => {
    let body = {
      lot_id: lotId,
      prevent_number: prevent_num_rm,
      prevent_number_type: prevent_num_type_rm,
      price: prevent_price_rm,
      username: appContext.acUsername,
      prevent_number_id: prevent_number_id,
    };
    try {
      setLoadingRmPrevent(true);
      let datas = await rmPreventApi(body);
      reflectorLotPrevent(datas);
      setprevent_num_rm("");
      setprevent_price_rm("");
      setprevent_num_type_rm("lot_2");
      setprevent_id_rm("");
      setLoadingRmPrevent(false);
      openNotificationWithIcon("success", "หวยอั้น", "ลบหวยอั้นสำเร็จ");
    } catch (e) {
      setLoadingRmPrevent(false);
      openNotificationWithIcon("error", "หวยอั้น", "ลบหวยอั้นไม่สำเร็จ");
    }
  };

  return (
    <div className={styles.box100}>
      <div className={styles.backBtn}>
        <div
          className={styles.backBtnIn}
          onClick={() => {
            navigate(pathRoutes.lotResualt);
          }}
        >
          {"< "}ย้อนกลับ
        </div>
      </div>

      <div className={styles.boxresualtset} style={{ paddingBottom: "100px" }}>
        {isAdminMain && (
          <div
            style={{ paddingTop: "30px" }}
            className={styles.headerSetResualt}
          >
            กำลังดูของ : {appContext.acUsername}
          </div>
        )}
        <div className={styles.headerTypeResualt}>
          {"[" +
            (checkEmpty(lot.lot_type) ? "" : lot.lot_type) +
            "]" +
            " " +
            (checkEmpty(lot.lot_name) ? "" : lot.lot_name)}
        </div>

        {(isAdminMain || true) && (
          <div>
            {(lot.lot_id == "51" ||
              lot.lot_id == "68" ||
              lot.lot_id == "67") && (
              <div>
                <div
                  style={{ paddingTop: "10px" }}
                  className={styles.headerSetResualt}
                >
                  ตั้งวันหวยออกถัดไป
                </div>
                <div style={{ display: "flex", paddingTop: "10px" }}>
                  <div style={{ width: "" }}>
                    <Input
                      ref={valueNextRef}
                      placeholder={"วันหวยออกถัดไป"}
                      value={lotDateNext}
                      onChange={(e) => {
                        let value = e.target.value;
                        value = value.trim();
                        setLotDateNext(value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key == "Tab") {
                          e.preventDefault();
                          saveNextRef.current.click();
                          valueNextRef.current.focus();
                          return;
                        } else if (e.key == "Enter") {
                          saveNextRef.current.click();
                          valueNextRef.current.focus();
                          return;
                        }
                        let value = e.target.value;
                        value = value.trim();
                        setLotDateNext(value);
                      }}
                    />
                  </div>
                </div>
                <div style={{ paddingTop: "10px" }}>
                  <Button
                    ref={saveNextRef}
                    type="primary"
                    onClick={() => {
                      if (loadingSave) return;
                      showSaveConfirmNext();
                    }}
                  >
                    {loadingSaveNext ? <LoadingCenterSpinSmall /> : "บันทึก"}
                  </Button>
                </div>
              </div>
            )}

            <div>
              <div
                style={{ paddingTop: "10px" }}
                className={styles.headerSetResualt}
              >
                ตั้งเวลาปิด{" "}
                <div className={styles.textsamll}>(ปรับทุก user)</div>
              </div>
              <div style={{ display: "flex", paddingTop: "10px" }}>
                <div style={{ width: "" }}>
                  <Input
                    ref={valueTimeRef}
                    placeholder={"เวลาปิดรับ"}
                    value={lotDateClose}
                    onChange={(e) => {
                      let value = e.target.value;
                      value = value.trim();
                      setLotDateClose(value);
                    }}
                    onKeyDown={(e) => {
                      if (e.key == "Tab") {
                        e.preventDefault();
                        saveTimeRef.current.click();
                        valueTimeRef.current.focus();
                        return;
                      } else if (e.key == "Enter") {
                        saveTimeRef.current.click();
                        valueTimeRef.current.focus();
                        return;
                      }
                      let value = e.target.value;
                      value = value.trim();
                      setLotDateClose(value);
                    }}
                  />
                </div>
              </div>
              <div style={{ paddingTop: "10px" }}>
                <Button
                  ref={saveTimeRef}
                  type="primary"
                  onClick={() => {
                    if (loadingSave) return;
                    showSaveConfirmDateClose();
                  }}
                >
                  {loadingSaveTime ? <LoadingCenterSpinSmall /> : "บันทึก"}
                </Button>
              </div>
            </div>

            <div>
              <div
                style={{ paddingTop: "50px" }}
                className={styles.headerSetResualt}
              >
                เลขที่ออกวัน{" "}
                <DatePicker
                  // value={lotDate}
                  // defaultValue={"2023-07-03"}
                  value={dayjs(lotDate, "YYYY-MM-DD")}
                  placeholder="วันที่"
                  onChange={(dates, dateString) => {
                    // console.log("dateString", dateString);
                    setLotDate(dateString);
                  }}
                />{" "}
                <div className={styles.textsamll}>(ปรับทุก user)</div>
              </div>
              <div style={{ display: "flex", paddingTop: "10px" }}>
                <div style={{ width: "" }}>
                  <Input
                    ref={refvaluetop}
                    type="number"
                    placeholder={"เลขออกบน"}
                    value={lotTop}
                    onChange={(e) => {
                      let value = e.target.value;
                      value = value.trim();
                      setLotTop(value);
                    }}
                    onKeyDown={(e) => {
                      if (e.key == "Tab") {
                        e.preventDefault();
                        // saveTimeRef.current.click();
                        valueBottomRef.current.focus();
                        return;
                      } else if (e.key == "Enter") {
                        // saveTimeRef.current.click();
                        valueBottomRef.current.focus();
                        return;
                      }
                      let value = e.target.value;
                      value = value.trim();
                      setLotTop(value);
                    }}
                    onWheel={(e) => {
                      e.target.blur();
                      e.stopPropagation();
                    }}
                  />
                </div>
                <div style={{ width: "", paddingLeft: "10px" }}>
                  <Input
                    ref={valueBottomRef}
                    type="number"
                    placeholder={"เลขออกล่าง"}
                    value={lotBottom}
                    onChange={(e) => {
                      let value = e.target.value;
                      value = value.trim();
                      setLotBottom(value);
                    }}
                    onKeyDown={(e) => {
                      if (e.key == "Tab") {
                        e.preventDefault();
                        saveResualtRef.current.click();
                        refvaluetop.current.focus();
                        return;
                      } else if (e.key == "Enter") {
                        saveResualtRef.current.click();
                        refvaluetop.current.focus();
                        return;
                      }
                      let value = e.target.value;
                      value = value.trim();
                      setLotBottom(value);
                    }}
                    onWheel={(e) => {
                      e.target.blur();
                      e.stopPropagation();
                    }}
                  />
                </div>
              </div>
              <div style={{ paddingTop: "10px" }}>
                <Button
                  ref={saveResualtRef}
                  type="primary"
                  onClick={() => {
                    if (loadingSave) return;
                    showSaveConfirm();
                  }}
                >
                  {loadingSave ? <LoadingCenterSpinSmall /> : "บันทึก"}
                </Button>
              </div>
            </div>
          </div>
        )}

        <div style={{ paddingTop: "10px" }} className={styles.headerSetResualt}>
          เลขออกทั้งหมด
        </div>
        <div>
          <Table
            className={styles.table}
            columns={columns}
            dataSource={lotResualts}
            pagination={false}
            rowClassName={styles.rowClassRotResualtSet}
          />
        </div>

        <div style={{ paddingTop: "50px", paddingBottom: "100px" }}>
          <div style={{ display: "flex" }}>
            <div className={styles.headerSetResualt}>การจ่าย</div>
            {(isAdminMain || true) && (
              <div style={{ paddingLeft: "20px" }}>
                <Button
                  type="primary"
                  onClick={() => {
                    if (loadingPaySave) return;
                    showSavePayConfirm();
                  }}
                >
                  {loadingPaySave ? <LoadingCenterSpinSmall /> : "บันทึก"}
                </Button>
              </div>
            )}
          </div>
          <div className={styles.textsamll}>
            (ปรับแค่ user :{" "}
            {(isAdminMain || true) ? appContext.acUsername : myUser.username})
          </div>

          <Table
            className={styles.table}
            columns={columnPays}
            dataSource={lotPays}
            pagination={false}
            rowClassName={styles.rowClassRotResualtSet}
          />
        </div>
        <div>
          <div
            style={{ paddingTop: "0px" }}
            className={styles.headerSetResualt}
          >
            เลขอั้น{" "}
            <div className={styles.textsamll}>
              (ปรับแค่ user :{" "}
              {(isAdminMain || true) ? appContext.acUsername : myUser.username})
            </div>
          </div>
          <div
            style={{
              display: "flex",
              paddingTop: "10px",
              alignItems: "center",
            }}
          >
            <div>ดึงข้อมูลจาก</div>
            <div style={{ width: "", paddingLeft: "10px" }}>
              <Select
                value={userOptionSelected}
                // defaultValue="lot_2"
                // style={{ width: 120 }}
                onChange={(v) => {
                  setUserOptionSelected(v);
                }}
                options={userOptions}
              />
            </div>
            <div style={{ paddingLeft: "10px" }}>มาทับ</div>
            <div style={{ paddingLeft: "10px" }}>
              <Button
                type="primary"
                onClick={() => {
                  if (loadingPreventData) return;
                  showSavePreventDataConfirm();
                }}
              >
                {loadingPreventData ? <LoadingCenterSpinSmall /> : "ดึงข้อมูล"}
              </Button>
            </div>
          </div>
          {/* {(isAdminMain || true) && ( */}
          <div>
            <div style={{ display: "flex", paddingTop: "10px" }}>
              <div style={{ width: "" }}>
                <Input
                  ref={numPreventRef}
                  type="number"
                  placeholder={"ใส่เลข"}
                  value={prevent_num}
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value.trim();
                    setprevent_num(value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key == "Tab") {
                      e.preventDefault();
                      // btn_add_win_ref.current.click();
                      pricePreventRef.current.focus();
                      return;
                    } else if (e.key == "Enter") {
                      // btn_add_win_ref.current.click();
                      pricePreventRef.current.focus();
                      return;
                    }
                    let value = e.target.value;
                    value = value.trim();
                    setprevent_num(value);
                  }}
                  onWheel={(e) => {
                    e.target.blur();
                    e.stopPropagation();
                  }}
                />
              </div>
              <div style={{ width: "", paddingLeft: "10px" }}>
                <Input
                  ref={pricePreventRef}
                  type="number"
                  placeholder={"จ่ายราคา"}
                  value={prevent_price}
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value.trim();
                    setprevent_price(value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key == "Tab") {
                      e.preventDefault();
                      // btn_add_win_ref.current.click();
                      typePreventRef.current.focus();
                      return;
                    } else if (e.key == "Enter") {
                      // btn_add_win_ref.current.click();
                      typePreventRef.current.focus();
                      return;
                    }
                    let value = e.target.value;
                    value = value.trim();
                    setprevent_price(value);
                  }}
                  onWheel={(e) => {
                    e.target.blur();
                    e.stopPropagation();
                  }}
                />
              </div>
              <div style={{ width: "", paddingLeft: "10px" }}>
                <Select
                  onKeyDown={(e) => {
                    if (e.key == "Tab") {
                      e.preventDefault();
                      savePreventRef.current.click();
                      numPreventRef.current.focus();
                      return;
                    } else if (e.key == "Enter") {
                      savePreventRef.current.click();
                      numPreventRef.current.focus();
                      return;
                    }
                  }}
                  ref={typePreventRef}
                  value={prevent_num_type}
                  defaultValue="lot_2"
                  // style={{ width: 120 }}
                  onChange={(v) => {
                    setprevent_num_type(v);
                  }}
                  options={[
                    { value: "lot_2", label: "2 ตัวตรง" },
                    { value: "lot_3_top", label: "3 ตัวตรง" },
                    { value: "lot_3_tot", label: "3 ตัวโต๊ด" },
                  ]}
                />
              </div>
            </div>
            <div style={{ paddingTop: "10px", display: "flex" }}>
              <div>
                <Button
                  ref={savePreventRef}
                  type="primary"
                  onClick={() => {
                    if (loadingPreventSave) return;
                    showSavePreventConfirm();
                  }}
                >
                  {loadingPreventSave ? <LoadingCenterSpinSmall /> : "บันทึก"}
                </Button>
              </div>
              <div style={{ paddingLeft: "10px" }}>
                <Button
                  type="primary"
                  danger
                  onClick={() => {
                    if (loadingPreventDelete) return;
                    showConfirmDeleteAll();
                  }}
                >
                  {loadingPreventDelete ? (
                    <LoadingCenterSpinSmall />
                  ) : (
                    "ลบทั้งหมด"
                  )}
                </Button>
              </div>
            </div>
          </div>
          {/* )} */}
          <Table
            className={styles.table}
            columns={columnPrevents}
            dataSource={lotPrevent}
            pagination={false}
            rowClassName={styles.rowClassRotResualtSet}
          />
        </div>

        <div>
          <div
            style={{ paddingTop: "50px" }}
            className={styles.headerSetResualt}
          >
            ปิดรับ <div className={styles.textsamll}>(ปรับทุก user)</div>
          </div>
          {(isAdminMain || true) && (
            <div>
              <div style={{ paddingTop: "0px" }}>
                ปิดรับงวด{" "}
                <DatePicker
                  value={dayjs(close_date, "YYYY-MM-DD")}
                  placeholder="วันที่"
                  onChange={(dates, dateString) => {
                    setclose_date(dateString);
                  }}
                />
              </div>

              <div>
                <div style={{ display: "flex", paddingTop: "10px" }}>
                  <div style={{ width: "" }}>
                    <Input
                      ref={valueCloseRef}
                      type="number"
                      placeholder={"ใส่เลข"}
                      value={close_num}
                      onChange={(e) => {
                        let value = e.target.value;
                        value = value.trim();
                        setclose_num(value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          saveCloseRef.current.click();
                          valueCloseRef.current.focus();
                          return;
                        }
                        let value = e.target.value;
                        value = value.trim();
                        setclose_num(value);
                      }}
                      onWheel={(e) => {
                        e.target.blur();
                        e.stopPropagation();
                      }}
                    />
                  </div>
                  <div style={{ width: "", paddingLeft: "10px" }}>
                    <Select
                      value={close_num_type}
                      defaultValue="lot_2"
                      // style={{ width: 120 }}
                      onChange={(v) => {
                        setclose_num_type(v);
                      }}
                      options={[
                        { value: "lot_2", label: "2 ตัว" },
                        { value: "lot_3", label: "3 ตัว" },
                        // { value: "lot_3_tot", label: "3 ตัวโต๊ด" },
                      ]}
                    />
                  </div>
                </div>
                <div style={{ paddingTop: "10px", display: "flex" }}>
                  <div>
                    <Button
                      ref={saveCloseRef}
                      type="primary"
                      onClick={() => {
                        if (loadingCloseSave) return;

                        showSaveCloseConfirm(close_num);
                        setclose_num("");
                      }}
                    >
                      {loadingCloseSave ? <LoadingCenterSpinSmall /> : "บันทึก"}
                    </Button>
                  </div>
                  <div style={{ paddingLeft: "10px" }}>
                    <Button
                      type="primary"
                      danger
                      onClick={() => {
                        if (loadingCloseDelete) return;
                        showConfirmDeleteAllClose();
                      }}
                    >
                      {loadingCloseDelete ? (
                        <LoadingCenterSpinSmall />
                      ) : (
                        "ลบทั้งหมด"
                      )}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <Table
            className={styles.table}
            columns={columnCloses}
            dataSource={lotClosees}
            pagination={false}
            rowClassName={styles.rowClassRotResualtSet}
          />
        </div>
      </div>

      {contextHolder}
      {contextHolderDone}

      <div
        style={{ paddingBottom: "50px", paddingTop: "0px" }}
        className={styles.backToTopDiv}
      >
        <Button
          onClick={() => {
            window.scrollTo(0, 0);
          }}
          className={styles.backToTop}
        >
          Back To Top
        </Button>
      </div>
    </div>
  );
}

export default LotResualtSet;
